import { Box, Typography } from "@mui/material";
import { muiTheme } from "@/styles/theme";
import NoResultsIcon from "@/assets/icons/no-results-icon";
import DOMPurify from "dompurify";

interface NoResultsProps {
  message?: string;
}

export const NoResults = ({ message }: NoResultsProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        borderRadius: "10px",
        padding: "10px",
        backgroundColor: muiTheme.colorSchemes.light.palette.background.white,
      }}
    >
      <NoResultsIcon />
      <Typography
        variant="h3_reg"
        sx={{
          textAlign: "center",
          whiteSpace: "pre-line",
          color: muiTheme.colorSchemes.light.palette.neutral[300],
        }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message ?? "No results to show") }}
      />
    </Box>
  );
};
